export default "__VITE_ASSET__RM2$_yTk__"